<style scoped="" type="text/css"></style>
<template>
  <el-date-picker style="width: 100%" v-model="times" :type="type" :format="format" value-format="timestamp" :disabled="disabled" :range-separator="$t('zhi4')" :placeholder="$t('xuanzeshijian')" :start-placeholder="$t('kaishishijian')" :end-placeholder="$t('jieshushijian')" :clearable="clearable" :picker-options="pickerOptions" @change="change" :default-time="times ? ['00:00:00', '23:59:59'] : null"> </el-date-picker>
</template>
<script type="text/javascript">
export default {
  name: 'normal_time',
  components: {},
  props: {
    is_current: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number
      //default: parseInt(new Date().getTime()/1000)
    },
    start: {
      type: Number
      //default:  parseInt(new Date().getTime()/1000)
    },
    end: {
      type: Number
      //default: parseInt(new Date().getTime()/1000)
    },
    //year/month/date/week/ datetime/datetimerange/daterange
    type: {
      type: String,
      default: 'datetimerange'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    minMaxBase: {
      type: String,
      default: 'selected' //current:当前系统时间  selected:当前选择时间
    },
    minTime: {
      type: Number,
      default: 0
    },
    maxTime: {
      type: Number,
      default: 0
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      times: null,
      pickerMinDate: '',
      pickerOptions: {}
    };
  },
  created() {
    if (this.maxTime > 0 || this.minTime > 0) {
      this.pickerOptions = {
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          if (this.minMaxBase == 'selected') {
            if (this.pickerMinDate) {
              console.log(22222);
              const max = this.maxTime - 1;
              const min = this.minTime;
              let maxTime = this.pickerMinDate + max;
              let minTime = this.pickerMinDate - min;
              return time.getTime() > maxTime || time.getTime() < minTime;
            }
          } else {
            const max = this.maxTime - 1;
            const min = this.minTime;
            let maxTime = new Date().getTime() + max;
            let minTime = new Date().getTime() - min;
            // console.log(maxTime+"||"+minTime+"||"+(new Date()).getTime())
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      };
    }

    this.resetTime();
    this.initTime();
  },
  watch: {
    time(n, o) {
      if (!n) {
        this.time = null;
      }
      this.initTime();
    },
    start(n, o) {
      if (!n) {
        this.start = null;
      }
      this.initTime();
    },
    end(n, o) {
      if (!n) {
        this.end = null;
      }
      this.initTime();
    },
    times(n, o) {
      if (!this.times || (Array.isArray(this.times) && this.times.length === 0)) {
        // 仅在父级仍有值（含 NaN）时回写 null，避免与 initTime 互相触发死循环
        if (this.start !== null && this.start !== undefined) {
          this.$emit('update:start', null);
        }
        if (this.end !== null && this.end !== undefined) {
          this.$emit('update:end', null);
        }
        if (this.time !== null && this.time !== undefined) {
          this.$emit('update:time', null);
        }
        return;
      }

      if (this.type == 'datetimerange' || this.type == 'daterange') {
        if (this.times[0] != null && !isNaN(this.times[0])) {
          this.$emit('update:start', parseInt(this.times[0]));
        }
        if (this.times[1] != null && !isNaN(this.times[1])) {
          this.$emit('update:end', parseInt(this.times[1]));
        }
      } else {
        if (this.times != null && !isNaN(this.times)) {
          this.$emit('update:time', parseInt(this.times));
        }
      }
    }
  },

  mounted() {},
  computed: {},
  methods: {
    change() {
      this.pickerMinDate = '';
      this.$emit('change');
    },
    resetTime() {
      if (this.is_current) {
        if (this.time == null) {
          //this.time = parseInt(new Date().getTime() / 1000);
          this.time = parseInt(new Date().getTime());
        }
        if (this.start == null) {
          this.start = parseInt(new Date().getTime());
        }
        if (this.end == null) {
          this.end = parseInt(new Date().getTime());
        }
      }
    },
    initTime() {
      //console.log(this.times)
      if (this.type == 'datetimerange' || this.type == 'daterange') {
        if (this.start == null || this.end == null || isNaN(this.start) || isNaN(this.end)) {
          this.times = [];
        } else {
          this.times = [this.start, this.end];
        }
      } else {
        this.times = this.time != null && !isNaN(this.time) ? this.time : null;
      }
    }
  }
};
</script>
